<template>
		<circle-spinner
			:size="this.size"
			:class="['erco-spinner', { '-fixed-color': isFixedColor }]"
		>
		</circle-spinner>
</template>

<script>
	import { Circle } from 'vue-loading-spinner';

	export default {
		name: 'ErcoSpinnerAtom',

		props: {
			isFixedColor: {
				type: Boolean,
				default: false,
			},
			size: {
				type: String,
				default: '60px',
			},
		},

		computed: {
			computedStyle() {
				return `background-color: ${this.backgroundColor};`;
			},
		},

		components: {
			'circle-spinner': Circle,
		},
	};
</script>


<style lang="scss">

	.erco-spinner {
		> .path {
			stroke: white;
			animation: circle-dash 1.4s ease-in-out infinite;
		}
		&.-fixed-color {
			> .path {
				stroke: orange;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoSpinner.vue?5589d1c0